$(document).ready(function () {
  //    if ($('body').hasClass('product')) {

  // var customColors = {
  //     "lilac": "#C8A2C8",
  //   "rose":"#FFC0CB",
  //   "sage":"#4d5d53",
  //   "metal":"#39648d",
  //   "amethyst":"#9966CC",
  //   "azure":"#007fff",
  //     // Add more custom color mappings as needed
  // };

  // $("label.color-swatch.cstm_cls span.sr-only").each(function() {
  //     var new_cstm = $(this).text().split(' ')[0].toLowerCase();
  //     console.log("New color:", new_cstm); // Check the value of new_cstm in the console

  //     var color = chroma.valid(new_cstm) ? new_cstm : customColors[new_cstm];

  //     // Check if color is valid
  //     if (chroma.valid(color)) {
  //         // Add class 'active' to the parent label
  //         $(this).parent('label').addClass('active');

  //         // Set the background color
  //         $(this).parent('label').css('background-color', color);
  //     } else {
  //         console.log("Invalid color value:", new_cstm);
  //     }
  // });

  //    }
  $.ajax({
    url: "https://geolocation-db.com/jsonp",
    jsonpCallback: "callback",
    dataType: "jsonp",
    success: function (location) {
      console.log(location);
      if (location.country_code !== "US") {
        $(
          "fieldset.Color .variant-picker__option-info .h-stack.gap-1 legend"
        ).text("Colour:");
         $(
          ".custom-color-swatches-product .heading-custm-color-swatc h3"
        ).text("Also Available in Other Colours");
      } else {
        $(
          "fieldset.Color .variant-picker__option-info .h-stack.gap-1 legend"
        ).text("Color:");
         $(
          ".custom-color-swatches-product .heading-custm-color-swatc h3"
        ).text("Also Available in Other Colors");
      }
    },
  });

  $(".arrow_section span.arrow_right").click(function () {
    var $current = $(
      "safe-sticky.product-gallery__thumbnail-list product-gallery-navigation.product-gallery__thumbnail-scroller button.product-gallery__thumbnail[aria-current='true']"
    );
    var $next = $current.next();
    if (!$next.length) {
      $next = $(
        "safe-sticky.product-gallery__thumbnail-list product-gallery-navigation.product-gallery__thumbnail-scroller button.product-gallery__thumbnail"
      ).first();
    }
    $next.click();
  });

  $(".arrow_section span.arrow_left").click(function () {
    var $current = $(
      "safe-sticky.product-gallery__thumbnail-list product-gallery-navigation.product-gallery__thumbnail-scroller button.product-gallery__thumbnail[aria-current='true']"
    );
    var $prev = $current.prev();
    if (!$prev.length) {
      $prev = $(
        "safe-sticky.product-gallery__thumbnail-list product-gallery-navigation.product-gallery__thumbnail-scroller button.product-gallery__thumbnail"
      ).last();
    }
    $prev.click();
  });

  $("span.size_chart_text").click(function () {
    $(".table-wrapper-size-chart").addClass("show_size_chart");
    $("body").addClass("active_popup");
  });
  $(".table-wrapper-size-chart span.close").click(function () {
    $(".table-wrapper-size-chart").removeClass("show_size_chart");
    $("body").removeClass("active_popup");
  });

  var size_chart_count = $(".table_size_chart_wrap table").length;

  if (size_chart_count == 0) {
    $("span.size_chart_text").css("display", "none");
  }
});




// pop-up-Jauery basis of cart price

// function checkCartPrice() {
//     var cartPriceText = $(".cart-drawer__button-price").text().trim();
//     console.log("Cart price text:", cartPriceText);
    
//     // Check if the cart price text contains a '$' symbol
//     if (cartPriceText.indexOf('$') !== -1) {
//         var cartPrice = parseFloat(cartPriceText.replace('$', ''));
//         console.log("Cart price:", cartPrice);
        
//         var popupOverlay = $("#popup-overlay");
//         if (cartPrice >= 120) {
//             // Add class if cart price is $120 or more
//             console.log("Adding class pop-show");
//             popupOverlay.addClass("pop-show");
//         } else {
//             // Remove class if cart price is less than $120
//             console.log("Removing class pop-show");
//             popupOverlay.removeClass("pop-show");
//         }
//     } else {
//         console.log("Cart price text does not contain '$' symbol.");
//     }
// }

$(document).ready(function() {
    // Event listener for quantity selector buttons
    $(document).on('click', '.quantity-selector__button', function() {
        setTimeout(checkCartPrice, 1500);
    });

    // Event listener for links
    $(document).on('click', 'a.link.text-xs', function() {
        setTimeout(checkCartPrice, 1500);
    });
  
        $(document).on('click', '.quick-buy-modal__content .buy-buttons .button.w-full', function() {
        setTimeout(checkCartPrice, 1500);
    });           
     $(document).on('click', '.product .buy-buttons .button.w-full', function() {
        setTimeout(checkCartPrice, 1500);
    });   

  
});

$(document).ready(function() {
    // Event listener for the "X" span
    $('#popup-close').click(function() {
        $("#popup-overlay").removeClass("pop-show");
    });
});




$('.icon-image-wrap').slick({
  infinite: true,
  autoplay: true,
  autoplaySpeed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,

      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 568,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});




$('.icon-image-wrap.slider-logo-custom').slick({
  infinite: true,
  autoplay: true,
  autoplaySpeed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,

      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 568,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
			

